import { useEffect } from 'react';
import {
  runSyncBootstrap,
  initSyncNotificationHandlers,
  initSyncBroadcast,
  startSyncPolling,
  stopSyncPolling,
} from '../services/syncService';
import { initNotificationService } from '../services/notificationService';

/** Login sonrası generic sync + background warmup + delta polling */
export default function SyncBootstrap() {
  useEffect(() => {
    const unsubBroadcast = initSyncBroadcast();
    const unsubNotif = initNotificationService();
    const unsubSync = initSyncNotificationHandlers();
    startSyncPolling();
    void runSyncBootstrap('cari', { warmup: true });
    return () => {
      stopSyncPolling();
      unsubBroadcast();
      unsubNotif();
      unsubSync();
    };
  }, []);
  return null;
}
